import { COMMUNITY_ROUTES } from '~/constants/community';
import stripTokenParams from '~/utils/stripTokenParams';

const buildCommunityModalPath = (
  modal: string,
  destination: string,
  extraParams: Record<string, string> = {},
): string => {
  const params = new URLSearchParams({ modal, redirect_to: stripTokenParams(destination), ...extraParams });
  return `${COMMUNITY_ROUTES.root}?${params.toString()}`;
};

export default buildCommunityModalPath;
